export default "/_next/static/fonts/Graphik-Bold-1cfe3bedc7b123e25ff0fe10269d721c.woff";